const API_URL = `${process.env.REACT_APP_API_URL}/v1/employer`;
// const API_URL = `https://seed.api.postflow.social/v1/admin`;

export const SIGNIN_URL = `${API_URL}/app-sign-in`;
export const UAC_URL = `${API_URL}/admin-uac`;
export const SUBMISSION_URL = `${API_URL}/submissions`;
export const GET_USER_REPORT_URL = `${API_URL}/user-report`;
export const GET_POST_STATS_URL = (id) => `${API_URL}/post-stats/${id}`;
export const GET_PAGE_STATS_URL = (id) => `${API_URL}/page-insight/${id}`;
export const OPPORTUNITY_URL = `${API_URL}/opportunity`;

export const SYNC_URL = `${API_URL}/sync`;
export const AGENT_UAC_URL = `${API_URL}/agent-uac`;
export const ADMIN_TOKEN_URL = `${API_URL}/admin-token`;
export const AI_PREVIEW_URL = `${API_URL}/ai-preview`;
export const USER_URL = `${API_URL}/user`;
export const GROUP_URL = `${API_URL}/group`;
export const AGENT_URL = (id) => `${API_URL}/agent/${id}`;
export const GET_COLLECTION_DATA = `${API_URL}/collection-data`;
export const GET_COLLECTION_AGGREGATE_DATA = `${API_URL}/collection-aggregate-data`;
export const GET_COL_AGGREGATE_DATA = `${API_URL}/col-aggregate-data`;
export const SEARCH_COLLECTION_URL = `${API_URL}/search-collection`;
export const ZONE_USER_COUNT_URL = (type, id) => `${API_URL}/zone-user-count/${type}/${id}`;
export const GET_MEMBERSHIP_REPORT_URL = `${API_URL}/membership-report`;
export const ASSIGNMENT_URL = `${API_URL}/assignment`;
export const GET_TEAM_REPORT_URL = (id) => `${API_URL}/team-report/${id}`;
export const GET_TEAM_USER_REPORT_URL = (id) => `${API_URL}/team-user-report/${id}`;
export const GET_TEAM_SOCIAL_REPORT_URL = (id) => `${API_URL}/team-social-report/${id}`;
export const TASK_URL = `${API_URL}/task`;
export const GET_AGENT_URL = (id) => `${API_URL}/agent/${id}`;
export const GET_TEAM_URL = (id) => `${API_URL}/team/${id}`;
export const GET_USER_URL = (id) => `${API_URL}/user/${id}`;
export const POLLING_STATION_URL = `${API_URL}/polling-station`;
export const SEND_MESSAGE_URL = `${API_URL}/send-message`;
export const MEDIA_URL = `${API_URL}/media`;
export const JOB_URL = `${API_URL}/job`;
export const GET_PRE_SIGNED_URL = `${API_URL}/generate-pre-signed-url`;
